import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c465acee&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CHeading: require('@chakra-ui/vue').CHeading, CFlex: require('@chakra-ui/vue').CFlex, CText: require('@chakra-ui/vue').CText, CIcon: require('@chakra-ui/vue').CIcon, CBox: require('@chakra-ui/vue').CBox, CLink: require('@chakra-ui/vue').CLink, CCollapse: require('@chakra-ui/vue').CCollapse, CDivider: require('@chakra-ui/vue').CDivider, CImage: require('@chakra-ui/vue').CImage, CSimpleGrid: require('@chakra-ui/vue').CSimpleGrid})
